import { useGeoLookupContext } from '@/hooks/useGeoLookupContext';
import { config } from '@/pageConfig/life/us/en';
import { LifePageTemplate } from '@/pageTemplate/LifePageTemplate';
import { Cookie } from '@lemonade-hq/nuiza';
import { useEffect } from 'react';
import { useCookies } from 'react-cookie';

export default function LifePage() {
  const { trackEventWithGeolocation } = useGeoLookupContext();
  const [cookies] = useCookies([Cookie.UUID]);

  useEffect(() => {
    trackEventWithGeolocation('life_page.viewed', {
      product: 'life',
      client_uuid: cookies[Cookie.UUID],
      experiment: 'bottom_sticky_cta_off',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [cookies]);

  return <LifePageTemplate config={config} />;
}
